<template>
  <div class="percent-dialog">
    <el-dialog
      title="分成设置（单位：%）"
      :visible.sync="dialogVisible"
      width="30%"
      center>
      <div style="text-align: center">
        <el-input-number style="width: auto!important" :value="percent" @change="handleChange" controls-position="right" :min="0" :max="100">
        </el-input-number>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="complete">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'audit-dialog',
  components: {},
  props: ['percent'],
  data() {
    return {
      dialogVisible: false,
    }
  },
  methods: {
    cancel() {
      this.hideModal()
    },
    handleChange(value) {
      this.$emit('update:percent', value)
    },
    complete() {
      if (!this.percent && this.percent !== 0) return this.$message.error('请输入分成比例')
      this.$emit('complete')
      this.hideModal()
    },
    showModal() {
      this.dialogVisible = true
    },
    hideModal() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.audit-dialog{
  /deep/ .el-textarea {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/PercentDialog.vue